var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`title-algin-${_vm.titleAlign} title`},[_c('h3',{class:`h1-size-${_vm.titleSize}`},[_vm._v(_vm._s(_vm.titleText))]),(_vm.subTitle)?_c('h5',{class:`h3-size-${_vm.titleSize}`},[_vm._v(_vm._s(_vm.subTitle))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }